const mixedBundles = function() {
  const mixedBundlesSwitches = document.querySelectorAll('.mixed-bundles__switch--product');
  const mixedBundlesProducts = document.querySelectorAll('.mixed-bundles__product-box');

  if (!mixedBundlesSwitches) return;
  mixedBundlesSwitches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      if (swatch.classList.contains('active')) return;

      // update swatchs
      mixedBundlesSwitches.forEach(el => el.classList.remove('active'));
      swatch.classList.add('active')

      // Update products
      mixedBundlesProducts.forEach(el => el.classList.remove('active'));
      document.querySelector(swatch.getAttribute('data-product')).classList.add('active');
    })
  })
}

document.addEventListener('DOMContentLoaded', mixedBundles);